// src/config/auth-config.js
export const cognitoAuthConfig = {
  authority:
    "https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_iwuucAKwz",
  client_id: "53uau5vnpnc3sv0et32okdoatv",
  redirect_uri: window.location.origin + "/auth-callback",
  response_type: "code",
  scope: "email openid profile",
};
